/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetCommonState400Response,
  GetCompanyMembers200Response,
  GetMetadata200Response,
  GetMetadata404Response,
  GetMetadata422Response,
  GetOptions200Response,
  SearchInstructions422Response,
  UtmSave200Response,
  UtmSave403Response,
  UtmSaveRequest,
} from '../models/index'
import {
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetCompanyMembers200ResponseFromJSON,
  GetCompanyMembers200ResponseToJSON,
  GetMetadata200ResponseFromJSON,
  GetMetadata200ResponseToJSON,
  GetMetadata404ResponseFromJSON,
  GetMetadata404ResponseToJSON,
  GetMetadata422ResponseFromJSON,
  GetMetadata422ResponseToJSON,
  GetOptions200ResponseFromJSON,
  GetOptions200ResponseToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
  UtmSave200ResponseFromJSON,
  UtmSave200ResponseToJSON,
  UtmSave403ResponseFromJSON,
  UtmSave403ResponseToJSON,
  UtmSaveRequestFromJSON,
  UtmSaveRequestToJSON,
} from '../models/index'

export interface GetMetadataRequest {
  type: string
  slug?: string
  page?: number
}

export interface UtmSaveOperationRequest {
  utmSaveRequest: UtmSaveRequest
}

/**
 * SiteGlobalApi - interface
 *
 * @export
 * @interface SiteGlobalApiInterface
 */
export interface SiteGlobalApiInterface {
  /**
   * Члены команды — записи типа team, выбранные на странице «О компании» (в порядке выбора). Ответ кэшируется в Redis.
   * @summary Команда компании
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteGlobalApiInterface
   */
  getCompanyMembersRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCompanyMembers200Response>>

  /**
   * Члены команды — записи типа team, выбранные на странице «О компании» (в порядке выбора). Ответ кэшируется в Redis.
   * Команда компании
   */
  getCompanyMembers(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCompanyMembers200Response>

  /**
   * SEO-метаданные (title, description, Open Graph) для страниц и записей сайта. Для типа pages slug обязателен; для архивных типов без slug отдаётся метаданные архива (учитывается page). Ответ кэшируется в Redis.
   * @summary SEO-метаданные страницы
   * @param {string} type Slug типа контента (pages, blog, news, services, team, ...)
   * @param {string} [slug] Slug записи (обязателен для type&#x3D;pages; для детальных записей)
   * @param {number} [page] Номер страницы архивной пагинации
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteGlobalApiInterface
   */
  getMetadataRaw(
    requestParameters: GetMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMetadata200Response>>

  /**
   * SEO-метаданные (title, description, Open Graph) для страниц и записей сайта. Для типа pages slug обязателен; для архивных типов без slug отдаётся метаданные архива (учитывается page). Ответ кэшируется в Redis.
   * SEO-метаданные страницы
   */
  getMetadata(
    requestParameters: GetMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMetadata200Response>

  /**
   * Общие данные сайта из группы настроек site_options: контакты, адрес, время работы. Ответ кэшируется в Redis.
   * @summary Общие данные сайта
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteGlobalApiInterface
   */
  getOptionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOptions200Response>>

  /**
   * Общие данные сайта из группы настроек site_options: контакты, адрес, время работы. Ответ кэшируется в Redis.
   * Общие данные сайта
   */
  getOptions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOptions200Response>

  /**
   * Фиксирует факт перехода посетителя с UTM-метками (публичный эндпоинт без авторизации, защищён middleware site-verify). Метки далее применяются к событиям регистрации/заявок. Обязателен хотя бы один UTM-параметр.
   * @summary Сохранение UTM-меток посетителя
   * @param {UtmSaveRequest} utmSaveRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteGlobalApiInterface
   */
  utmSaveRaw(
    requestParameters: UtmSaveOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UtmSave200Response>>

  /**
   * Фиксирует факт перехода посетителя с UTM-метками (публичный эндпоинт без авторизации, защищён middleware site-verify). Метки далее применяются к событиям регистрации/заявок. Обязателен хотя бы один UTM-параметр.
   * Сохранение UTM-меток посетителя
   */
  utmSave(
    requestParameters: UtmSaveOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UtmSave200Response>
}

/**
 *
 */
export class SiteGlobalApi
  extends runtime.BaseAPI
  implements SiteGlobalApiInterface
{
  /**
   * Члены команды — записи типа team, выбранные на странице «О компании» (в порядке выбора). Ответ кэшируется в Redis.
   * Команда компании
   */
  async getCompanyMembersRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCompanyMembers200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/company-members`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCompanyMembers200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Члены команды — записи типа team, выбранные на странице «О компании» (в порядке выбора). Ответ кэшируется в Redis.
   * Команда компании
   */
  async getCompanyMembers(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCompanyMembers200Response> {
    const response = await this.getCompanyMembersRaw(initOverrides)
    return await response.value()
  }

  /**
   * SEO-метаданные (title, description, Open Graph) для страниц и записей сайта. Для типа pages slug обязателен; для архивных типов без slug отдаётся метаданные архива (учитывается page). Ответ кэшируется в Redis.
   * SEO-метаданные страницы
   */
  async getMetadataRaw(
    requestParameters: GetMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMetadata200Response>> {
    if (requestParameters['type'] == null) {
      throw new runtime.RequiredError(
        'type',
        'Required parameter "type" was null or undefined when calling getMetadata().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    if (requestParameters['slug'] != null) {
      queryParameters['slug'] = requestParameters['slug']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/seo`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetMetadata200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * SEO-метаданные (title, description, Open Graph) для страниц и записей сайта. Для типа pages slug обязателен; для архивных типов без slug отдаётся метаданные архива (учитывается page). Ответ кэшируется в Redis.
   * SEO-метаданные страницы
   */
  async getMetadata(
    requestParameters: GetMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMetadata200Response> {
    const response = await this.getMetadataRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Общие данные сайта из группы настроек site_options: контакты, адрес, время работы. Ответ кэшируется в Redis.
   * Общие данные сайта
   */
  async getOptionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetOptions200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/options`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetOptions200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Общие данные сайта из группы настроек site_options: контакты, адрес, время работы. Ответ кэшируется в Redis.
   * Общие данные сайта
   */
  async getOptions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetOptions200Response> {
    const response = await this.getOptionsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Фиксирует факт перехода посетителя с UTM-метками (публичный эндпоинт без авторизации, защищён middleware site-verify). Метки далее применяются к событиям регистрации/заявок. Обязателен хотя бы один UTM-параметр.
   * Сохранение UTM-меток посетителя
   */
  async utmSaveRaw(
    requestParameters: UtmSaveOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UtmSave200Response>> {
    if (requestParameters['utmSaveRequest'] == null) {
      throw new runtime.RequiredError(
        'utmSaveRequest',
        'Required parameter "utmSaveRequest" was null or undefined when calling utmSave().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/v1/seo/utm-save`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UtmSaveRequestToJSON(requestParameters['utmSaveRequest']),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UtmSave200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Фиксирует факт перехода посетителя с UTM-метками (публичный эндпоинт без авторизации, защищён middleware site-verify). Метки далее применяются к событиям регистрации/заявок. Обязателен хотя бы один UTM-параметр.
   * Сохранение UTM-меток посетителя
   */
  async utmSave(
    requestParameters: UtmSaveOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UtmSave200Response> {
    const response = await this.utmSaveRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
